import { render, staticRenderFns } from "./projectselector.vue?vue&type=template&id=63a1abda"
import script from "./projectselector.vue?vue&type=script&lang=js"
export * from "./projectselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports